module.exports = __webpack_public_path__ + "img/搜索 (2).4e9ce234.png";